var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsNumberSideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 119,
    viewBox: "0 0 163 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9469 52.8554C23.3841 43.9535 20.7932 37.3134 18.5879 31.9998C13.4646 19.6551 21.422 3.1528 34.7868 3.00548L127.802 1.98014C136.455 1.88476 143.555 8.80577 143.681 17.4582L144.897 101.204C145.025 110.011 137.886 117.202 129.078 117.139L38.7815 116.488C37.0503 116.475 35.3259 116.195 33.7204 115.547C20.7964 110.332 8.96823 99.9281 16.304 86.668C23.0848 74.4109 24.7521 78.0777 26.9998 72.4908C27.808 70.482 27.7514 54.8657 26.9469 52.8554Z",
    fill: "#C7C7C7",
    stroke: "#C7C7C7",
    strokeWidth: 3.1414,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6539 52.8554C39.0911 43.9535 36.5003 37.3134 34.295 31.9998C29.1716 19.6551 37.129 3.1528 50.4938 3.00548L143.509 1.98014C152.162 1.88476 159.262 8.80577 159.388 17.4582L160.604 101.204C160.732 110.011 153.593 117.202 144.785 117.139L54.4885 116.488C52.7573 116.475 51.0329 116.195 49.4274 115.547C36.5034 110.332 24.6753 99.9281 32.011 86.668C38.7919 74.4109 40.4591 78.0777 42.7069 72.4908C43.5151 70.482 43.4585 54.8657 42.6539 52.8554Z",
    fill: "#0C92D1",
    stroke: "#0C94D3",
    strokeWidth: 3.1414,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsNumberSideIcon);
export default __webpack_public_path__ + "static/media/AnalyticsNumberSideIcon.8b00ea08a799bf4f0496dd5acbd988d6.svg";
export { ForwardRef as ReactComponent };